<template>
  <header>
    <a href="#" class="d-flex align-items-center">
      <div class="logo-pic"></div>
      <div class="logo-title ml-1">
        <h2>uizify</h2>
      </div>
    </a>

    <div class="right-side d-flex align-items-center">
      <router-link to="/" class="log-out mr-2" v-if="!isAllQuizes">ALL QUIZES</router-link>
      <button class="log-out mr-2" @click="logout()">LOG OUT</button>
      <div class="user-pic"></div>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  methods: {
    logout() {
      sessionStorage.removeItem("userToken");
      location.reload();
    }
  },
  computed: {
    isAllQuizes() {
      return this.$router.history.current.name === "All Quizes";
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/variables";

header {
  display: flex;
  background-color: $blue;
  flex-wrap: wrap;
  padding: 0.7rem 1rem;

  .logo-pic,
  .user-pic {
    width: 2.2rem;
    height: 2.2rem;
    border-radius: 50%;
  }

  .logo-title h2 {
    color: white;
    font-size: 1.4rem;
    font-weight: 700;
  }

  .right-side {
    margin-left: auto;
  }

  .logo-pic {
    background-image: url("../assets/images/Logo_180.png");
    background-position: center center;
    background-size: 100% 100%;
  }

  .user-pic {
    background-image: url("../assets/images/user-pic.jpg");
    background-position: center center;
    background-size: 100% 100%;
  }

  .log-out {
    background-color: transparent;
    color: #fff;
    border: none;
    outline: none;
    padding: 5px;
    font-weight: 600;
  }
}
</style>
